import PAGES from "./pages";
import { ValueOf } from "./utils";

export const COMMITMENT_UPFRONT_TYPE = "now";

export const MONTH_NAMES_NB = [
    "Januar",
    "Februar",
    "Mars",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Desember",
];

export const PAYMENT_METHOD = {
    ADYEN_CC: "AdyenCardPayment",
    NETS: "nets_payments",
    NETS_3D: "nets3d_payments",
    VIPPS: "nets_vipps_payments",
    VIPPS_v2: "vipps_payments",
    INVOICE: "invoice_payments",
    VOUCHER: "voucher_payments",
} as const;

export type PaymentMethod = ValueOf<typeof PAYMENT_METHOD>;
export type PaymentMethodKey = keyof typeof PAYMENT_METHOD;

export const GET_CUSTOMER_TYPE = {
    WELCOME: "welcome",
    EXISTING: "existing",
};
export const GET_CUSTOMER_TYPES = [GET_CUSTOMER_TYPE.WELCOME, GET_CUSTOMER_TYPE.EXISTING];

export const INVOICE_TYPE = {
    LETTER: "letter",
    EMAIL: "email",
};

export const RAPID_ORDER_TYPE = {
    // prepaid
    PREPAID_REFILL_ORDER: "PREPAID_REFILL_ORDER",
    PREPAID_REGISTRATION_ORDER: "PREPAID_REGISTRATION_ORDER",
    // transfer and portin
    TRANSFER_ORDER: "TRANSFER_ORDER",
    TRANSFER_B2B_TO_B2C: "TRANSFER_B2B_TO_B2C",
    TRANSFER_B2B_TO_B2B: "TRANSFER_B2B_TO_B2B",
    TRANSFER_B2C_TO_B2C: "TRANSFER_B2C_TO_B2C",
    TRANSFER_B2C_TO_B2B: "TRANSFER_B2C_TO_B2B",
    PORTIN_B2B_TO_B2C: "PORTIN_B2B_TO_B2C",
    PORTIN_B2B_TO_B2B: "PORTIN_B2B_TO_B2B",
    PORTIN_B2C_TO_B2C: "PORTIN_B2C_TO_B2C",
    PORTIN_B2C_TO_B2B: "PORTIN_B2C_TO_B2B",
    NORMAL_ORDER: "NORMAL_ORDER",
    ONBOARDING_B2B_ORDER: "ONBOARDING_B2B_ORDER",
    UPDATE_PORTIN_DATE_ORDER: "UPDATE_PORTIN_DATE_ORDER",
    // webshop b2c
    WEBSHOP_B2C_SIMONLY_PORTIN: "WEBSHOP_B2C_SIMONLY_PORTIN",
    WEBSHOP_B2C_SIMONLY_NEW_NUMBER: "WEBSHOP_B2C_SIMONLY_NEW_NUMBER",
    WEBSHOP_B2C_SIMONLY_EXISTING: "WEBSHOP_B2C_SIMONLY_EXISTING",
    WEBSHOP_B2C_SIMONLY_MIX: "WEBSHOP_B2C_SIMONLY_MIX",
    WEBSHOP_B2C_HW_BUNDLE_PORTIN: "WEBSHOP_B2C_HW_BUNDLE_PORTIN",
    WEBSHOP_B2C_HW_BUNDLE_NEW_NUMBER: "WEBSHOP_B2C_HW_BUNDLE_NEW_NUMBER",
    WEBSHOP_B2C_HW_BUNDLE_EXISTING: "WEBSHOP_B2C_HW_BUNDLE_EXISTING",
    WEBSHOP_B2C_HW_BUNDLE_MIX: "WEBSHOP_B2C_HW_BUNDLE_MIX",
    WEBSHOP_B2C_HW_ONLY: "WEBSHOP_B2C_HW_ONLY",
    WEBSHOP_B2C_MBB_HW_BUNDLE: "WEBSHOP_B2C_MBB_HW_BUNDLE",
    WEBSHOP_B2C_MBB_SIM_ONLY: "WEBSHOP_B2C_MBB_SIM_ONLY",
    WEBSHOP_B2C_SERVICE_SUBSCRIPTION: "WEBSHOP_B2C_SERVICE_SUBSCRIPTION",
    WEBSHOP_FWA: "WEBSHOP_FWA",
    WEBSHOP_PREPAID: "WEBSHOP_PREPAID",
    WEBSHOP_B2B_HW_ONLY: "WEBSHOP_B2B_HW_ONLY",
    WEBSHOP_B2B_MBB_HW_BUNDLE: "WEBSHOP_B2B_MBB_HW_BUNDLE",
    WEBSHOP_B2B_MBB_SIM_ONLY: "WEBSHOP_B2B_MBB_SIM_ONLY",
    RETAIL_ORDER: "RETAIL_ORDER",
} as const;

export type RapidOrderType = ValueOf<typeof RAPID_ORDER_TYPE>;

export const CART_ITEM_TYPE = {
    SUBSCRIPTION: "SUBSCRIPTION",
    SUBSCRIPTION_DRAFT: "SUBSCRIPTION_DRAFT",
    HANDSET: "HANDSET",
    HANDSET_PREOWNED: "HANDSET-PREOWNED",
    MODEM: "MODEM",
    TABLET: "TABLET",
    WEARABLE: "WEARABLE",
    CONNECTED_DEVICE: "CONNECTED_DEVICE",
    ACCESSORY: "ACCESSORY",
    DELIVERY: "DELIVERY",
    WEBDEAL: "WEBDEAL",
    SIM: "SIM",
    ESIM: "ESIM",
    PREPAID_REFILL: "PREPAID_REFILL",
    NEW_NUMBER: "NEW_NUMBER",
    BREAKAGE_FEE: "BREAKAGE_FEE",
    SWITCH_BREAKAGE_FEE: "SWITCH_BREAKAGE_FEE",
    SWITCH_REMAINING_COST: "SWITCH_REMAINING_COST",
    SPECIALPRODUCT: "SPECIALPRODUCT",
    SERVICE: "SERVICE",
    IN_SHOP_SERVICE: "IN_SHOP_SERVICE",
    VOUCHER: "VOUCHER",
    RESWITCH_PLACEHOLDER: "RESWITCH_PLACEHOLDER",
    RESWITCH_EXISTING_HARDWARE: "RESWITCH_EXISTING_HARDWARE",
    TRANSFER: "TRANSFER",
    MOBILE_REFUND: "MOBILE_REFUND",
} as const;

export type CartItemTypeValues = ValueOf<typeof CART_ITEM_TYPE>;

export const CART_ITEM_SKU_TYPES: CartItemTypeValues[] = [
    CART_ITEM_TYPE.HANDSET,
    CART_ITEM_TYPE.HANDSET_PREOWNED,
    CART_ITEM_TYPE.MODEM,
    CART_ITEM_TYPE.TABLET,
    CART_ITEM_TYPE.WEARABLE,
];

export const CART_ITEM_HANDSET_TYPES: CartItemTypeValues[] = [CART_ITEM_TYPE.HANDSET, CART_ITEM_TYPE.HANDSET_PREOWNED];

export const CART_ITEM_SUBSCRIPTION_TYPES: CartItemTypeValues[] = [
    CART_ITEM_TYPE.SUBSCRIPTION,
    CART_ITEM_TYPE.SUBSCRIPTION_DRAFT,
];

export const CART_ITEM_SIM_AND_NEW_NUMBER_TYPES: CartItemTypeValues[] = [
    CART_ITEM_TYPE.SUBSCRIPTION,
    CART_ITEM_TYPE.SUBSCRIPTION_DRAFT,
    CART_ITEM_TYPE.SPECIALPRODUCT,
];

export const HARDWARE_TYPE = {
    HANDSET: "handset",
    HANDSET_PREOWNED: "handset-preowned",
    ACCESSORY: "accessory",
    TABLET: "tablet",
    MODEM: "modem",
    SIM: "sim",
    ESIM: "esim",
    WEBDEAL: "webdeal",
    SPECIAL_PRODUCT: "specialproduct",
    WEARABLE: "wearable",
    CONNECTED_DEVICE: "connected_device",
    IN_SHOP_SERVICE: "in_shop_service",
} as const;

export type ProductInfoMiniType = keyof typeof HARDWARE_TYPE;
export type HardwareType = ValueOf<typeof HARDWARE_TYPE>;

export const INSURANCE_TWO_MONTHS_FREE_CODES = [
    "INSURANCE_SWITCH_4+INSURLS4V",
    "INSURANCE_PLUS_L_BAN+INSBNPL",
    "INSURANCE_PLUS_M_BAN+INSBNPM",
    "INSURANCE_PLUS_S_BAN+INSBNPS",
    "INSURANCE_SCREEN_L_BAN+INSBNSL",
    "INSURANCE_SCREEN_M_BAN+INSBNSM",
    "INSURANCE_SCREEN_S_BAN+INSBNSS",
    "INSURANCE_PLUS_L_PREOWNED_BAN+INSBNPLFL",
    "INSURANCE_PLUS_M_PREOWNED_BAN+INSBNPLFM",
    "INSURANCE_PLUS_S_PREOWNED_BAN+INSBNPLFS",
];

export const CART_PAYMENT_TYPE = {
    MONTHLY: "price.monthly",
    UPFRONT: "price.upfront",
    UPFRONT_WITHOUT_VAT: "price.upfrontWithoutVAT",
    FIRSTINVOICE: "price.firstInvoice",
};

export type CartPaymentTypeValue = ValueOf<typeof CART_PAYMENT_TYPE>;

export const CREDIT_CHECK_DECISION = {
    CC_AND_LOOKUP: "OK",
    ONLY_CC: "CONTROL",
    DENIED: "DENIED",
    OK_WITH_CREDITLIMIT: "OK_WITH_CREDITLIMIT",
    SCORE_NOT_AVAILABLE: "SCORE_NOT_AVAILABLE",
    INVALID_NATIONAL_IDENTITY_NUMBER: "INVALID_NATIONAL_IDENTITY_NUMBER",
} as const;

export type CreditCheckDecisionType = ValueOf<typeof CREDIT_CHECK_DECISION>;

export const CREDITCHECK_OR_ADDRESS_LOOKUP_TYPE = {
    NOT_REQUIRED: "not_required",
    REQUIRES_ADDRESS_LOOKUP: "requires_address_lookup",
    REQUIRES_CREDITCHECK: "requires_creditcheck",
    CUSTOMER_LOOKUP_ONLY: "customer_lookup_only",
} as const;

export type CreditCheckOrAddressLookupType = ValueOf<typeof CREDITCHECK_OR_ADDRESS_LOOKUP_TYPE>;

export const PHONE_NUMBER_LEN = 8;
export const MBB_NUMBER_LEN = 12;
export const FORMATTED_PHONE_NUMBER_LEN = 10;
export const SMS_VERIFICATION_CODE_LEN = 4;
export const NEARBY_SHOP_THRESHOLD_KM = 30;
export const LEGAL_OWNER_MIN_AGE = 18;
export const MAX_AGE_BARN = 16; // Will allow up to 15 years and 364 days old
export const MAX_AGE_UNG = 30; // Will allow up to 29 years and 364 days old
export const MAX_NUMBER_OF_ALLOWED_SUBSCRIPTIONS = 10;
export const MAX_NUMBER_OF_ALLOWED_NEW_SUBSCRIPTIONS = 5;
export const NUMBER_OF_BARRINGS_FOR_CHILDREN = 6;

export const SIM_PICK_UP_IN_STORE_SKU = "9066374";

export const NEW_ACCOUNT_VALUE = "new";

export const CHECKOUT_LABELS_NOSUBSCRIPTIONS = ["Opplysninger", "Levering", "Betaling", "Ferdig"];
export const CHECKOUT_LABELS_UPRONT_SUBSCRIPTIONS = (isNoDelivery: boolean) => [
    "Eier",
    "Bruker",
    isNoDelivery ? "Oppsummering" : "Levering",
    "Betaling",
    "Ferdig",
];
export const CHECKOUT_LABELS_SUBSCRIPTIONS_GROUPED = (isNoDelivery: boolean) => [
    "Eier",
    "Bruker",
    isNoDelivery ? "Oppsummering" : "Levering",
    "Ferdig",
];

export const CHECKOUT_LABELS_SUBSCRIPTIONS_GROUPED_EXTERNAL = (isNoDelivery: boolean) => [
    "Velg",
    "Eier",
    "Bruker",
    isNoDelivery ? "Oppsummering" : "Levering",
    "Ferdig",
];
export const CHECKOUT_LABELS_SERVICE_SUBSCRIPTIONS = ["BankID", "Bruker", "Ferdig"];
export const CHECKOUT_LABELS_MBB = ["Eier", "Levering", "Ferdig"];
export const CHECKOUT_LABELS_MBB_UPFRONT = ["Eier", "Levering", "Betaling", "Ferdig"];
export const TRANSFER_OWNERSHIP_LABELS = ["Bekreft ID", "Bekreft nummer", "Se over", "Bestill eierskifte"];
export const FWA_LABELS = ["Velg pakke", "Verifisering", "Oppsummering", "Bekreftelse"];
export const TELIA_PLAY_LABELS = ["Eier", "Oppsummering", "Bekreftelse"];
export const REFILL_LABELS = ["Velg nummer", "Velg pakke", "Oppsummering", "Kvittering"];
export const ONBOARDINGB2B_LABELS = ["Logg inn", "Kontaktinfo", "Abonnement", "Oppsummering", "Bekreftelse"];
export const RETAILER_SUBSCRIPTION_LABELS = ["Abonnement", "SIM-kort", "Bruker"];

export const CHECKOUT_LINKS = [PAGES.CHECKOUT.PERSONAL_DETAILS.URL, PAGES.CHECKOUT.SUMMARY.URL, "#", "#"];

export const CHECKOUT_LINKS_UPFRONT_SUBSCRIPTIONS = [
    PAGES.CHECKOUT.PERSONAL_DETAILS.URL,
    PAGES.CHECKOUT.ADD_MEMBER.URL,
    "#",
    "#",
    "#",
];
export const CHECKOUT_LINKS_SERVICE_SUBSCRIPTIONS = [
    PAGES.CHECKOUT.PERSONAL_DETAILS.URL,
    PAGES.CHECKOUT.ADD_MEMBER.URL,
    "#",
];
export const CHECKOUT_LINKS_B2B = [PAGES.CHECKOUT_B2B.PERSONAL_DETAILS.URL, PAGES.CHECKOUT_B2B.SUMMARY.URL, "#"];
export const CHECKOUT_LINKS_SUBSCRIPTIONS_GROUPED = [
    PAGES.CHECKOUT.PERSONAL_DETAILS.URL,
    PAGES.CHECKOUT.ADD_MEMBER.URL,
    PAGES.CHECKOUT.SUMMARY.URL,
    "#",
];
export const CHECKOUT_LINKS_SUBSCRIPTIONS_GROUPED_EXTERNAL = [
    PAGES.LISTING_PAGES.SIMONLY.URL,
    PAGES.CHECKOUT.PERSONAL_DETAILS.URL,
    PAGES.CHECKOUT.ADD_MEMBER.URL,
    PAGES.CHECKOUT.SUMMARY.URL,
    "#",
];
export const TRANSFER_OWNERSHIP_LINKS = [
    PAGES.TRANSFER_OWNERSHIP.CONFIRM_ID.URL,
    PAGES.TRANSFER_OWNERSHIP.CONFIRM_NUMBER.URL,
    PAGES.TRANSFER_OWNERSHIP.SUMMARY.URL,
    PAGES.TRANSFER_OWNERSHIP.REQUEST_TRANSFER_OF_OWNERSHIP.URL,
];

export const FWA_LINKS = [
    PAGES.FWA.CHOOSE_SUBSCRIPTION.URL,
    PAGES.FWA.CUSTOMER.URL,
    PAGES.FWA.PERSONAL_DETAILS.URL,
    PAGES.FWA.RECEIPT.URL,
];

export const TELIA_PLAY_LINKS = [
    PAGES.TELIA_PLAY.CUSTOMER.URL,
    PAGES.TELIA_PLAY.SUMMARY.URL,
    PAGES.TELIA_PLAY.RECEIPT.URL,
];

/** HTTP status returned by the Telia Play select-package API when the package is not available at the address */
export const TELIA_PLAY_PACKAGE_NOT_AVAILABLE_STATUS = 409;

export const ONBOARDING_B2B_LINKS = [
    PAGES.ONBOARDING_B2B.URL,
    PAGES.ONBOARDING_B2B.CONTACT_INFORMATION.URL,
    PAGES.ONBOARDING_B2B.SUBSCRIPTION_DETAILS.URL,
    PAGES.ONBOARDING_B2B.SUMMARY.URL,
    PAGES.ONBOARDING_B2B.RECEIPT.URL,
];

export const VERIFICATION_TARGET = {
    // make acronym of the values cause going to use them in DisplayableRapidShopError = should not be readable values
    TRANSFER_OWNERSHIP_TO_B2C: "TRANSFER_OWNERSHIP_TO_B2C", //"transfer qwnership telia B2C/B2B -> telia B2C",
    FORMER_LEGAL_OWNER_CONSENT_TRANSFER_B2B: "FORMER_LEGAL_OWNER_CONSENT_TRANSFER_B2B", //"former legal owner consent when transfer ownership telia B2B -> telia B2C",
    FORMER_LEGAL_OWNER_CONSENT_PORTIN_B2B: "FORMER_LEGAL_OWNER_CONSENT_PORTIN_B2B", //"former legal owner consent when portin a number from external provider to telia B2B",
    ESIM_INSTALLMENT_B2B: "ESIM_INSTALLMENT_B2B", // "esimInstallmentB2B",
} as const;

export type VerificationTarget = ValueOf<typeof VERIFICATION_TARGET>;

export const FORM_ID = {
    PERSONAL_DETAILS: "personalDetailsForm",
    PERSONAL_DETAILS_FWA: "personalDetailsFwaForm",
    PERSONAL_DETAILS_TELIA_PLAY: "personalDetailsTeliaPlayForm",
    BUSINESS_DETAILS: "businessDetailsForm",
    REGISTER_PREPAID: "registerPrepaidForm",
    REFILL_PREPAID: "refillPrepaidForm",
    ADD_MEMBER: "addMemberForm",
    EDIT_DELIVERY_ADDRESS: "editDeliveryAddressForm",
    CONTACT_INFO: "contactInfoForm",
    TRANSFER_OWNERSHIP: "transferOwnership",
    DSF_MISMATCH: "dsfMismatchForm",
    INCOMPLETE_ORDER: "incompleteOrderForm",
    ONBOARDING_EMAIL: "onboardingEmailForm",
    CREDIT_CHECK: "creditCheckForm",
    RETAILER_LOOKUP: "retailerLookupForm",
    CUSTOMER_IDENTIFICATION: "customerIdentificationForm",
    CUSTOMER_CONTACT_INFO: "customerContactInfoForm",
    CUSTOMER_PRODUCT_USER: "customerProductUserForm",
    EQUIPMENT_REGISTRATION: "equipmentRegistrationForm",
    IMEI_REGISTRATION: "imeiRegistrationForm",
} as const;

export type FormId = ValueOf<typeof FORM_ID>;

export const NUMBER_TYPE = {
    EIGHT_DIGITS: "8_digits",
    TWELVE_DIGITS: "12_digits",
    TWELVE_DIGITS_VAS: "12_digits_vas",
};

export const CUSTOMER_BILLING_TYPE = {
    PREPAID: "prepaid",
    POSTPAID: "postpaid",
    CONTROL: "control",
} as const;

export type CustomerBillingType = ValueOf<typeof CUSTOMER_BILLING_TYPE>;

export const VERIFICATION_TYPE = {
    PIN: "PIN",
    LOGIN: "LOGIN",
    BANK_ID: "BANK_ID",
    CANDOUR: "CANDOUR",
    DRIVERS_LICENSE: "DRIVERS_LICENSE",
    PASSPORT: "PASSPORT",
    NATIONAL_ID_CARD: "NATIONAL_ID_CARD",
    KNOWN_BY_SALES_AGENT: "KNOWN_BY_SALES_AGENT",
} as const;

export type VerificationType = ValueOf<typeof VERIFICATION_TYPE>;

export const INITIATED_FROM_TYPE = {
    MINSIDE: "minside",
    APP: "app",
} as const;

export type InitiatedFrom = ValueOf<typeof INITIATED_FROM_TYPE>;

export const PROVIDER_ALIAS: { [key: number]: string } = {
    705: "Talkmore",
    833: "Dipper",
    873: "Dipper",
    736: "MyCall",
    898: "Onecall",
    707: "Phonero",
    708: "Phonero",
    822: "Phonero",
    885: "Phonero",
    830: "Fjordkraft",
    745: "Telipol",
};

export const CAMPAIGN_ID = {
    // Keep one for reference to future campaigns
    VPL_3: "NCVPLCH02+NCVPLBNG2",
};

export const REALM = {
    B2C: "b2c",
    B2B: "b2b",
} as const;

export const D2D_DEALER_GROUP = "SDU_D2D";
export const EXTERNAL_RETAIL_CHAINS: string[] = ["ELKJOP", "POWER"];
export const DEALER_CODES = {
    // Handle dealers that are not a part of Elkjøp and Power in a separate category.
    // When we include more dealsers (ala POS/Tango/etc) later - we can change this logic
    TM_INTERNAL: ["GINS"],
    TM_EXTERNAL: ["NMAS", "GCTL"],
    D2D: ["GSAL"],
} as const;

const hasDealerCode = (codes: readonly string[], dealerCode?: string): boolean =>
    !!dealerCode && codes.includes(dealerCode.toUpperCase());

export const EXTERNAL_RETAIL_DEALER_GROUPS = ["Elkjøp", "Expert", "External_campaign"] as const;

export const isExternalRetailDealerGroup = (dealerGroup?: string): boolean =>
    !!dealerGroup && EXTERNAL_RETAIL_DEALER_GROUPS.some((group) => group.toLowerCase() === dealerGroup.toLowerCase());

export const isD2DDealerCode = (dealerCode?: string): boolean => hasDealerCode(DEALER_CODES.D2D, dealerCode);
export const isInternalTMDealerCode = (dealerCode?: string): boolean =>
    hasDealerCode(DEALER_CODES.TM_INTERNAL, dealerCode);
export const isExternalTMDealerCode = (dealerCode?: string): boolean =>
    hasDealerCode(DEALER_CODES.TM_EXTERNAL, dealerCode);

export type Realm = ValueOf<typeof REALM>;

export const OCM_ORDER_STATE = {
    DRAFT: "DRAFT",
    PREREQUISITES_NEEDED: "PREREQUISITES_NEEDED",
    VALIDATION_FAILED: "VALIDATION_FAILED",
    VALIDATION_OK: "VALIDATION_OK",
    PROCESSING: "PROCESSING",
    VALIDATING: "VALIDATING",
    SUBMITTING: "SUBMITTING",
    FINALIZED: "FINALIZED",
    COMPLETED: "COMPLETED",
    SUBMITTING_FAILED: "SUBMITTING_FAILED",
} as const;

export const COMPLETED_STATES: readonly OrderStatus[] = [
    OCM_ORDER_STATE.PROCESSING,
    OCM_ORDER_STATE.FINALIZED,
    OCM_ORDER_STATE.COMPLETED,
];

export const CAN_CONTINUE_ORDER_STATES: readonly OrderStatus[] = [
    OCM_ORDER_STATE.DRAFT,
    OCM_ORDER_STATE.VALIDATION_FAILED,
    OCM_ORDER_STATE.VALIDATION_OK,
    OCM_ORDER_STATE.PREREQUISITES_NEEDED,
    OCM_ORDER_STATE.VALIDATING,
    OCM_ORDER_STATE.SUBMITTING_FAILED,
];

export const ORDER_STATES_ELIGIBLE_FOR_SUMMARY: readonly OrderStatus[] = [
    OCM_ORDER_STATE.PROCESSING,
    OCM_ORDER_STATE.VALIDATING,
    OCM_ORDER_STATE.SUBMITTING,
    OCM_ORDER_STATE.FINALIZED,
    OCM_ORDER_STATE.COMPLETED,
    OCM_ORDER_STATE.VALIDATION_OK,
    OCM_ORDER_STATE.PREREQUISITES_NEEDED,
];

export const SUBMITTED_STATES: ReadonlySet<OrderStatus> = new Set<OrderStatus>([
    OCM_ORDER_STATE.SUBMITTING,
    OCM_ORDER_STATE.PROCESSING,
    OCM_ORDER_STATE.FINALIZED,
    OCM_ORDER_STATE.COMPLETED,
]);

export const STATES_THAT_ALLOW_CHECKS: readonly OrderStatus[] = [
    OCM_ORDER_STATE.DRAFT,
    OCM_ORDER_STATE.VALIDATION_OK,
    OCM_ORDER_STATE.VALIDATION_FAILED,
    OCM_ORDER_STATE.SUBMITTING_FAILED,
];

export type OrderStatus = ValueOf<typeof OCM_ORDER_STATE>;

export const AB_TESTS = {
    AB18: "AB18",
    AB24: "AB24",
    AB37: "AB37",
};

export const DISCOUNT_TYPE = {
    MAIN_PERCENTAGE: "MAIN_PERCENTAGE",
    MAIN_AMOUNT: "MAIN_AMOUNT",
    MAIN_FINAL: "MAIN_FINAL",
    MAIN_N_FOR_M: "MAIN_N_FOR_M",
    ADD_PERCENTAGE: "ADD_PERCENTAGE",
    ADD_AMOUNT: "ADD_AMOUNT",
    ADD_FINAL: "ADD_FINAL",
};

export const MAX_NUM_SIM_DEALS_ALLOWED = 5;

export const MISSING_IMEI_MAX_DAYS_BACK = 60;

export const HARDWARE_TYPES_WHERE_ONLY_ONE_LEASE_OR_SWITCH_IS_ALLOWED: HardwareType[] = [
    HARDWARE_TYPE.HANDSET,
    HARDWARE_TYPE.HANDSET_PREOWNED,
    HARDWARE_TYPE.TABLET,
    HARDWARE_TYPE.WEARABLE,
];

export const TELIA_SKY_SERVICE = "SKYXCH01";
export const isTeliaSkyService = (serviceCode: string): boolean =>
    serviceCode.includes(TELIA_SKY_SERVICE) || serviceCode.includes("SKYCH01");
export const TELIA_TRYGG_SERVICE = "TRYCH05";

export const TELIA_SKY_SUBSCRIPTIONS = [
    "TELIA_MOBIL_X_RASK_VT",
    "TELIA_MOBIL_X_RASK_VT_2026",
    "TELIA_MOBIL_X_UNG",
    "TELIA_MOBIL_X_UNG_2026",
    "TELIA_X_MAX_2025",
    "TELIA_X_MAX_2026",
    "TELIA_X_MAX_2027",
    "TELIA_X_START_2027",
    "TELIA_X_START_2025",
    "TELIA_X_START_2026",
    "TELIA_X_MAX_PLUS_2025",
    "TELIA_X_MAX_PLUS_2026",
    "TELIA_X_MAX_PLUS_2027",
    "TELIA_X_BASIC_2025",
    "TELIA_X_BASIC_2026",
    "TELIA_X_BASIC_2027",
    "TELIA_X_BASIC_2025_2",
    "TELIA_MOBIL_X_UNG_2025_2",
    "TELIA_MOBIL_X_UNG_2026",
    "TELIA_X_INTRO+PROMO_INTRO_02_199",
    "TELIA_X_INTRO_2026+PROMO_INTRO_02_199",
];
export const TELIA_TRYGG_SUBSCRIPTIONS = [
    "TELIA_X_MAX_PLUS_2025",
    "TELIA_X_MAX_PLUS_2026",
    "TELIA_X_MAX_PLUS_2027",
    "TRYGG_B2C",
    "TRYGG_B2C_FAMILY",
    "TRYGG_B2C_INDIVIDUAL",
    "TRYGG_B2C_TEST",
];

export const IDENTIFICATION_METHODS = {
    BANK_ID: "BankId",
    DRIVERS_LICENSE: "Førerkort",
    PASSPORT: "Pass",
    NATIONAL_ID_CARD: "Nasjonalt ID-kort",
    KNOWN_BY_SALES_AGENT: "Kjent av selger",
};

export type IdentificationMethod = keyof typeof IDENTIFICATION_METHODS;

// Internal TM dealers may only identify customers with BankID or "Kjent av selger".
export const INTERNAL_TM_IDENTIFICATION_METHODS: IdentificationMethod[] = ["BANK_ID", "KNOWN_BY_SALES_AGENT"];
